import React, { useState, useEffect } from "react";
import { Info } from "lucide-react";
import { api } from "../api";

export default function Settings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getSettings().then((s) => {
      setSettings(s);
      setLoading(false);
    });
  }, []);

  if (loading) return null;

  return (
    <div className="animate-fade-in">
      <div className="mb-7">
        <h1 className="font-display text-[30px] font-extrabold mb-1 text-text-primary tracking-tight">
          Settings
        </h1>
        <div className="text-[14px] text-text-muted">
          Current configuration — edit via <code className="font-mono text-[12px] bg-surface-2 px-1.5 py-0.5 rounded-md border border-white/5">backend/.env</code> and restart the app
        </div>
      </div>

      <div className="grid gap-4 max-w-[600px]">
        {[
          { label: "Tenant Email", value: settings.tenant_email },
          { label: "Landlord Calendar", value: settings.landlord_calendar },
          { label: "Property Address", value: settings.property_address },
          {
            label: "Default Electricity Split",
            value: `${Math.round(settings.default_electricity_split * 100)}%`,
          },
          {
            label: "Default Other Split",
            value: `${Math.round(settings.default_other_split * 100)}%`,
          },
        ].map(({ label, value }) => (
          <div
            key={label}
            className="glass-panel p-4 px-5 flex justify-between items-center transition-colors hover:bg-surface-2"
          >
            <span className="text-[13px] text-text-secondary">{label}</span>
            <span className="font-mono text-[13px] font-semibold text-text-primary">
              {value}
            </span>
          </div>
        ))}

        <div className="bg-accent-light/50 border border-accent/20 rounded-xl p-3.5 px-4.5 flex gap-2.5 text-[13px] text-accent-dark items-start backdrop-blur-sm shadow-[inset_0_1px_1px_rgba(232,133,58,0.05)] mt-2">
          <Info size={15} className="mt-[1px] shrink-0 text-accent" />
          <span className="leading-relaxed">
            Split percentages set here are defaults for new bills.
            You can override the split on any individual unfinalized bill from the Dashboard.
          </span>
        </div>
      </div>
    </div>
  );
}
